import type { TFunction } from 'i18next'
import { toast } from 'sonner'

export const GROVE_NAME_MAX = 40
export const GROVE_DESCRIPTION_MAX = 200
export const GROVE_MESSAGE_MAX = 1000
export function groveErrorCode(err: unknown): string | null {
  const data = (err as { data?: { kind?: string; code?: string } } | null)?.data
  return data?.kind === 'grove' ? (data.code ?? null) : null
}

// Returns the error code so callers can branch (e.g. open the paywall on proRequired).
export function toastGroveError(err: unknown, t: TFunction): string | null {
  const code = groveErrorCode(err)
  toast.error(t(`groves.errors.${code ?? 'generic'}`))
  return code
}

// Shared via the marketing site, which serves the OG card and redirects here.
export function inviteLink(code: string) {
  const origin = import.meta.env.PROD ? 'https://goaltree.ai' : window.location.origin
  return `${origin}/groves/join/${code}`
}

export function timeAgo(ms: number, locale: string) {
  const mins = Math.round((Date.now() - ms) / 60_000)
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  if (mins < 1) return rtf.format(0, 'minute')
  if (mins < 60) return rtf.format(-mins, 'minute')
  const hours = Math.round(mins / 60)
  if (hours < 24) return rtf.format(-hours, 'hour')
  return rtf.format(-Math.round(hours / 24), 'day')
}
